import { BaseService } from 'core/services';
import InsuranceCoverageStatusOverviewRouteService from './InsuranceCoverageStatusOverviewRouteService';

class InsuranceCoverageStatusOverviewService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new InsuranceCoverageStatusOverviewRouteService());
    }
    getDownloadUrl(){
        return this.apiClient.appOptions.apiUrl + this.routeService.download();
    }

    getEmailPrefillData(facilityOrderId) {
        const url = this.routeService.getEmailPrefillData(facilityOrderId);
        return this.apiClient.get(url);
    }

    getNikoEmailPrefillData(facilityOrderId) {
        const url = this.routeService.getNikoEmailPrefillData(facilityOrderId);
        return this.apiClient.get(url);
    }

    sendEmail(resource) {
        const url = this.routeService.sendEmail(resource);
        return this.apiClient.post(url, resource);
    }

    sendEmailManually(resource){
        const url = this.routeService.sendEmailManually(resource);
        return this.apiClient.post(url, resource);
    }
}

export default InsuranceCoverageStatusOverviewService;
